import React from 'react';
import { Card, Typography, Collapse, Space } from 'antd';
import { QuestionCircleOutlined, WhatsAppOutlined, SettingOutlined, TeamOutlined, TrophyOutlined, BarChartOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;
const { Panel } = Collapse;

const Help = () => {
  const faqData = [
    {
      key: '1',
      icon: <WhatsAppOutlined style={{ color: '#25D366' }} />,
      title: 'Como sincronizar meu grupo do WhatsApp?',
      content: (
        <div>
          <Paragraph>Para sincronizar seu grupo com o Futezap:</Paragraph>
          <ol>
            <li>Adicione o código UUID ao nome do seu grupo</li>
            <li>Adicione os contatos obrigatórios: +55 11 95880-1116 e +55 11 96980-4357</li>
            <li>Clique em "Sincronizar" na página de sincronização</li>
            <li>Aguarde a mensagem de confirmação no grupo</li>
            <li>Clique em "Concluir Sincronização"</li>
          </ol>
          <Text type="secondary">Após a sincronização, as convocações serão enviadas automaticamente.</Text>
        </div>
      )
    },
    {
      key: '2',
      icon: <SettingOutlined style={{ color: '#1890ff' }} />,
      title: 'Como configurar os horários das convocações?',
      content: (
        <div>
          <Paragraph>Na página de Configuração você pode:</Paragraph>
          <ul>
            <li><strong>Dia da semana:</strong> Definir quando acontecem os jogos</li>
            <li><strong>Horário:</strong> Definir o horário do jogo</li>
            <li><strong>Número de jogadores:</strong> Quantos jogadores de linha e goleiros</li>
            <li><strong>Convocações:</strong> Configurar quando enviar (5, 4, 3, 2 dias antes às 11h por padrão)</li>
          </ul>
          <Text type="secondary">As configurações são aplicadas automaticamente aos próximos jogos.</Text>
        </div>
      )
    },
    {
      key: '3',
      icon: <TeamOutlined style={{ color: '#52c41a' }} />,
      title: 'Como gerenciar jogadores?',
      content: (
        <div>
          <Paragraph>Na página de Jogadores você pode:</Paragraph>
          <ul>
            <li><strong>Adicionar jogadores:</strong> Clique em "Novo Jogador" e preencha os dados</li>
            <li><strong>Editar informações:</strong> Clique diretamente nos campos para editar</li>
            <li><strong>Tipos de jogador:</strong> Mensalista (sempre convocado, recebe convocação antecipada 24h antes e tem preferência) ou Avulso (convocado quando necessário)</li>
            <li><strong>Posições:</strong> Jogador de Linha ou Goleiro</li>
            <li><strong>Buscar:</strong> Use a barra de pesquisa para encontrar jogadores</li>
          </ul>
          <Text type="secondary">Alterações são salvas automaticamente.</Text>
        </div>
      )
    },
    {
      key: '4',
      icon: <TrophyOutlined style={{ color: '#faad14' }} />,
      title: 'Como funciona o sistema de jogos?',
      content: (
        <div>
          <Paragraph>O sistema de jogos funciona assim:</Paragraph>
          <ul>
            <li><strong>Criação automática:</strong> Jogos são criados automaticamente baseados na configuração</li>
            <li><strong>Convocações:</strong> Mensagens são enviadas nos dias configurados</li>
            <li><strong>Confirmações:</strong> Jogadores respondem pelo WhatsApp</li>
            <li><strong>Status:</strong> Vai jogar (verde), Fora (vermelho), Espera (amarelo), Não confirmado (cinza)</li>
            <li><strong>Ações:</strong> Você pode cancelar, confirmar ou adicionar convidados</li>
          </ul>
          <Text type="secondary">O sistema gerencia automaticamente a lista de confirmados.</Text>
        </div>
      )
    },
    {
      key: '5',
      icon: <BarChartOutlined style={{ color: '#722ed1' }} />,
      title: 'Como interpretar a frequência dos jogadores?',
      content: (
        <div>
          <Paragraph>A página de Frequência mostra:</Paragraph>
          <ul>
            <li><strong>Últimos 60 jogos:</strong> Histórico de participação de cada jogador</li>
            <li><strong>Porcentagem:</strong> % de jogos que o jogador participou</li>
            <li><strong>Cores:</strong> Verde (alta frequência), Amarelo (média), Vermelho (baixa)</li>
            <li><strong>Exportar:</strong> Baixe os dados em Excel para análise</li>
          </ul>
          <Text type="secondary">Use esses dados para identificar jogadores mais e menos assíduos.</Text>
        </div>
      )
    },
    {
      key: '6',
      icon: <WhatsAppOutlined style={{ color: '#25D366' }} />,
      title: 'Posso gerenciar meu time pelo WhatsApp?',
      content: (
        <div>
          <Paragraph><strong>Sim! Você pode gerenciar seu time diretamente pelo WhatsApp.</strong></Paragraph>
          <Paragraph>Para acessar o menu de gerenciamento:</Paragraph>
          <ul>
            <li>Envie uma mensagem para o número: <strong>11 96721-4717</strong></li>
            <li>Digite "MENU" para ver as opções disponíveis</li>
            <li>Gerencie jogadores, jogos e configurações pelo chat</li>
            <li>Receba notificações e atualizações em tempo real</li>
          </ul>
          <Text type="secondary">O gerenciamento pelo WhatsApp oferece praticidade para ações rápidas do dia a dia.</Text>
        </div>
      )
    },
    {
      key: '7',
      icon: <QuestionCircleOutlined style={{ color: '#eb2f96' }} />,
      title: 'Dicas importantes de uso',
      content: (
        <div>
          <Paragraph><strong>Dicas para melhor experiência:</strong></Paragraph>
          <ul>
            <li>Mantenha os dados dos jogadores sempre atualizados</li>
            <li>Verifique regularmente se o grupo está sincronizado</li>
            <li>Use jogadores "Mensalistas" para o time fixo</li>
            <li>Use jogadores "Avulsos" para reforços eventuais</li>
            <li>Monitore a frequência para identificar padrões</li>
            <li>Configure as convocações de acordo com seu grupo</li>
          </ul>
          <Text type="secondary">Em caso de dúvidas, use o chat de suporte no canto da tela.</Text>
        </div>
      )
    }
  ];

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto', padding: 24 }}>
      <Card>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <QuestionCircleOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
          <Title level={2}>Central de Ajuda</Title>
          <Paragraph style={{ fontSize: 16, color: '#666' }}>
            Encontre respostas para as principais dúvidas sobre o Futezap
          </Paragraph>
        </div>

        <Collapse 
          size="large"
          expandIconPosition="end"
        >
          {faqData.map(item => (
            <Panel 
              key={item.key}
              header={
                <Space>
                  {item.icon}
                  <Text strong style={{ fontSize: 16 }}>{item.title}</Text>
                </Space>
              }
            >
              {item.content}
            </Panel>
          ))}
        </Collapse>

        <div style={{ 
          marginTop: 32, 
          padding: 24, 
          background: '#f6ffed', 
          border: '1px solid #b7eb8f', 
          borderRadius: 8,
          textAlign: 'center'
        }}>
          <Title level={4} style={{ color: '#389e0d', marginBottom: 8 }}>
            Precisa de mais ajuda?
          </Title>
          <Paragraph style={{ marginBottom: 0 }}>
            Use o chat de suporte no canto da tela ou entre em contato conosco.
            Nossa equipe está sempre pronta para ajudar!
          </Paragraph>
        </div>
      </Card>
    </div>
  );
};

export default Help;